<template>
    <RemoteTable ref="table" :form="form" :table="table">
        <template #default="{row, property}">
            <el-switch v-if="property === 'status'"
                       v-model="row.status.value" @change="changeStatus(row.id, $event)"
                       active-value="enable" inactive-value="disable"></el-switch>
        </template>
    </RemoteTable>
</template>

<script>
    import RemoteTable from '@/components/RemoteTable'
    import JSEncrypt from "jsencrypt";

    export default {
        components: {
            RemoteTable,
        },
        data() {
            return {
                form: {
                    configs: [
                        {label: "部门", name: "code", type: "select", op: "beginwith", value: "", options: this.$root.customers},
                        {label: "名称", name: "name", type: "input", op: "contains", value: ""},
                        {label: "账号", name: "account", type: "input", value: ""},
                        {label: "状态", name: "status", type: "select", value: "", url: "/dict/list/public/status"},
                    ],
                    tools: [
                        {
                            icon: "el-icon-plus", click: () => {
                              this.$router.push("/business/0")
                            }
                        },
                        {
                            label: "导出",
                            click: () => {
                              this.$confirm("确认进行导出操作？", "提示", {
                                confirmButtonText: "确认",
                                cancelButtonText: "取消",
                                type: 'warning'
                              }).then(() => {
                                this.$axios.post("/business/download", this.$refs.table.getQueryInfo()).then((response) => {
                                  this.$utils.download("/file/pop/" + response);
                                })
                              });
                            }
                        }
                    ]
                },
                table: {
                    urlPrefix: "/business",
                    columns: [
                        {label: "业务名称", name: "name"},
                        {label: "业务账号", name: "account", width: 150},
                        {label: "签名", name: "sign", width: 270},
                        {label: "余额", name: "balance", width: 100, sortable: true},
                        {label: "状态", name: "status", width: 80},
                        {label: "创建时间", name: "createTime", width: 150},
                    ],
                    tools: [
                        {
                            icon: "el-icon-refresh-right", content: "重置密码", click: (row) => {
                                this.$confirm('', '提示', {
                                    distinguishCancelAndClose: true,
                                    confirmButtonText: '重置登录密码',
                                    cancelButtonText: '重置API密码',
                                    type: 'warning'
                                }).then(() => {
                                    this.$prompt('请输入新密码', '重置登录密码', {
                                        confirmButtonText: '确定',
                                        cancelButtonText: '取消',
                                        inputPattern: /^\S{6,20}$/,
                                        inputErrorMessage: '密码长度在 6 到 20 个字符'
                                    }).then(({value}) => {
                                        this.$utils.post("/business/resetpass", {
                                            id: row.id,
                                            type: "login",
                                            pwd: this.encrypt(value)
                                        }, () => {
                                            this.$message.success("登录密码已重置！");
                                        })
                                    });
                                }).catch((action) => {
                                    if (action === 'close') {
                                        return;
                                    }
                                    
                                    this.$prompt('请输入新密码', '重置API密码', {
                                        confirmButtonText: '确定',
                                        cancelButtonText: '取消',
                                        inputPattern: /^\S{6,20}$/,
                                        inputErrorMessage: '密码长度在 6 到 20 个字符'
                                    }).then(({value}) => {
                                        this.$utils.post("/business/resetpass", {
                                            id: row.id,
                                            type: "api",
                                            pwd: this.encrypt(value)
                                        }, () => {
                                            this.$message.success("API密码已重置！");
                                        })
                                    });
                                });
                            }
                        }
                    ],
                    disableDelete: true
                }
            }
        },
        methods: {
            changeStatus(id, status) {
                this.$axios.post("/business/edit", {
                    id: id,
                    status: {value: status}
                }).then((result) => {
                    this.$utils.handleResult(result, () => {
                        this.$refs.table.load();
                    })
                })
            },
          encrypt(text) {
            const publicKty = "MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAjDMAZ8dLWV8zxzvDBDeJRYVGqyfhhauAZfl3eF6xnRcJjMadDW8CNPKqYSl5sLtqV8vbQdO1gJLYDOAwjEahkZnf1ftHjM7tFyQlWrUMqyPEmNRtPiJd//7ybitGdJ/VkaHI65qA/DkN5q+u523G3jK+1CdGp5UCcImqIZAwIx2pR8ZN7NyXoAcau+XbG2tFAp5A4FBhEjcJn6nDUzJiqqF6p1VpD9csi/45L5v6ruxy/oao5LrC22GImvI7rMRawXRy3u/k1VQZEN7dzl91wbZzBIdBjebfdTFWOdHpiPbBSYu9xihoT9csG0ZNA3LKR203xFkWEoz+pQq89KHpBwIDAQAB";
            const encrypt = new JSEncrypt();
            encrypt.setPublicKey(publicKty);
            return encrypt.encrypt(text);
          }
        }
    }
</script>